import { Typography } from '@mui/material';
import { useHeaderTitle } from 'pages/AppManagement/hooks/UseHeaderTitle';
import { makeSelectPageTitle } from 'pages/AppManagement/selectors';
import { useSelector } from 'react-redux';
import React from 'react';

const HeaderTitle: React.FC = () => {
  const pageTitle = useHeaderTitle();

  const title = pageTitle ? pageTitle : useSelector(makeSelectPageTitle());

  return (
    <Typography component="h2" variant="h2" color="text.primary" noWrap sx={{ flexGrow: 1, color: '#FFF' }}>
      {title}
    </Typography>
  );
};

export default HeaderTitle;
